import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { type LandingPageConfig } from "./entity";

export const LandingPageConfigEntityConfig: HyperEntityConfig<LandingPageConfig> = {
  allowApiRead: Roles.SuperAdmins,
  allowApiCrud: Roles.SuperAdmins,

  allowInsertPerRole(allow) {
    allow(Roles.SuperAdmins, true);
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.SuperAdmins, true);
  },
};
